export const API_URL = "";

export const API_KEY = "dafee2d8881142d4aca170343221404";

export const config = {
  API_URL: "https://api.weatherapi.com/v1",
  API_KEY: "dafee2d8881142d4aca170343221404",
};

export const PROJECT_NAME = "WEATHY";

export const DEFAULT_SELECTED_CITY = "Kiev";
